import { render, staticRenderFns } from "./BuildInformation.vue?vue&type=template&id=3ab1f151&scoped=true"
import script from "./BuildInformation.vue?vue&type=script&lang=js"
export * from "./BuildInformation.vue?vue&type=script&lang=js"
import style0 from "./BuildInformation.vue?vue&type=style&index=0&id=3ab1f151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab1f151",
  null
  
)

export default component.exports